import { PropsWithChildren } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { CurrencyCode, Vehicle } from 'further-types/lp/vehicle';
import { revaluation as rules } from 'further-ui/validations';
import FormWithStateContextProvider from 'contexts/FormWithStateContext';
import { AssetHistoryType } from 'further-types/lp/asset';
import { CalendarTime } from 'further-ui/utils';

export type AssetFullHistoryItem = {
  holdingClassId?: string;
  type: AssetHistoryType;
  holdingClassName: string;
  currency: CurrencyCode;
  ledgerDate: Date;
  unitPriceTcy: number;
  unitPriceLcy?: number;
  currentNumberOfUnits: number;
  assetId?: string;
  revaluationId?: string;
  createdAt?: CalendarTime;
};

export type RevaluationExternalState = {
  selectedVehicle: Vehicle;
  assetFullHistory: Record<string, Array<AssetFullHistoryItem>>;
};

type Props = {
  formMethods: UseFormReturn<rules.RevaluationFormType>;
  externalState: RevaluationExternalState;
};

const FormWrapper: React.FC<PropsWithChildren<Props>> = ({
  children,
  formMethods,
  externalState,
}) => {
  return (
    <FormWithStateContextProvider
      formMethods={formMethods}
      initialState={externalState}
    >
      {children}
    </FormWithStateContextProvider>
  );
};

export default FormWrapper;
